import React from "react";
import AppRoutes from "./AppRoutes";

function App() {
  return (
    <div className="App bg-white text-slate-900">
      <AppRoutes />
    </div>
  );
}

export default App;
